import type { IChatMessageFromHistory } from '@core/types/chat-message.types';
import type { IR2Attachment } from '@common/types/api/r2-types';

export const CHAT_ACTION_NAME = {
    selection: 'selection',
    attachDocument: 'attachDocument',
    documentChat: 'documentChat',
    clipboard: 'clipboard',
    history: 'history',
    img: 'img',
} as const;

export const CHAT_ATTACHMENT_LABEL = {
    chatDocument: 'chatDocument',
} as const;

export type IChatActionName = (typeof CHAT_ACTION_NAME)[ keyof typeof CHAT_ACTION_NAME ];
type IChatInputActionHandler = (action: IChatInputActionItem) => unknown;
export interface IChatInputActionItem
{
    value: boolean;
    onBuildData: IChatInputActionHandler;
}

export type IChatActionList = Record<IChatActionName, IChatInputActionItem>;

export interface IChatActionsData
{
    documentAttachments?: IR2Attachment[];
    oneTimeDocumentChat?: boolean;
    [ CHAT_ACTION_NAME.selection ]: string;
    [ CHAT_ACTION_NAME.attachDocument ]: string;
    [ CHAT_ACTION_NAME.documentChat ]: string;
    [ CHAT_ACTION_NAME.clipboard ]: string;
    [ CHAT_ACTION_NAME.history ]: IChatMessageFromHistory[];
    [ CHAT_ACTION_NAME.img ]: boolean;
}

export abstract class ChatActionBase
{
    public abstract setTextToHost(text: string): Promise<void>;
    public abstract setImageToHost(image: string): Promise<void>;
    public abstract isEditableHost(): boolean;
    public abstract isReadableDocumentHost(): boolean;
    public abstract getSelectedContentFromHost(): Promise<string>;
    public abstract getFullDocumentFromHost(): Promise<string>;
    public abstract getActions(): IChatActionList;
    public abstract getActionsData(): Promise<IChatActionsData>;
}
